import { render, staticRenderFns } from "./UserSideMenu.vue?vue&type=template&id=19b21a57"
import script from "./UserSideMenu.vue?vue&type=script&lang=js"
export * from "./UserSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports